import {inject, Injectable} from '@angular/core';
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {
  defaultRecordsDataRequestQueryParams
} from "../../../../../../../core/models/default-records-data-request-query-params";
import {
  GetSelectDataParams,
  RecordUpdateRequestParams,
  SelectData
} from "../../../../../../../core/types/records-table.types";
import {BaseCompetitorArticleData, CompetitorArticleData} from "../types/competitor-article-data.types";
import {CompetitorArticlesApiService} from "../services-api/competitor-articles-api.service";
import {productGroupTypeLazy} from "../configs/competitor-articles-lazy-property";

@Injectable({
  providedIn: 'root'
})
export class CompetitorArticlesService {
  private competitorArticlesApiService: CompetitorArticlesApiService = inject(CompetitorArticlesApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public fetchCompetitorArticlesData(competitorBrandId: number): Promise<Array<CompetitorArticleData>> {
    const queryParams = {
      ...defaultRecordsDataRequestQueryParams,
      size: undefined,
      competitorBrandId: competitorBrandId
    };

    return new Promise((resolve, reject) => {
      this.competitorArticlesApiService.fetchCompetitorArticlesData(queryParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public createCompetitorArticleData(data: BaseCompetitorArticleData): Promise<CompetitorArticleData> {
    return new Promise((resolve, reject) => {
      this.competitorArticlesApiService.createCompetitorArticleData(data).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updateCompetitorArticleField(updateRecordParams: RecordUpdateRequestParams): Promise<CompetitorArticleData> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<CompetitorArticleData>(updateRecordParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteCompetitorArticleData(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.competitorArticlesApiService.deleteCompetitorArticleData(id).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public fetchProductGroupSelectData(): Promise<Array<SelectData>> {
    const params: GetSelectDataParams = {
      propertyLazySelect: productGroupTypeLazy
    };

    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(params).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
